(function ($) {
	objectFitPolyfill();

	var body = $('body');

	AOS.init({
		duration: 600,
		easing: 'ease-in-out',
	});



	if ($(document)
		.scrollTop() >= 100) {
		body.addClass('scrolled')
	}


	$(document)
		.scroll(function () {
			if ($(this)
				.scrollTop() >= 100) {
				body.addClass('scrolled')
			} else {
				body.removeClass('scrolled')
			}
		});

	var body = $('body');
	$('.toggle-menu, .menu-close')
		.on('click', function (e) {
			body.toggleClass('open-menu');
			e.preventDefault();
		});

	var myEl = document.getElementById("offcanvas")
	var hammertime = new Hammer(myEl);
	hammertime.on('swipeleft', function (ev) {
		body.toggleClass('open-menu');
	});

	$('#myBtn').click(function (e) {
		$("#formModal").toggle();
		e.preventDefault();
	});

	$('#closeModal').click(function (e) {
		$("#formModal").toggle();
		e.preventDefault();
	});

	$('.sub-menu-toggle').on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('open');
	})

    $(document).on('gform_confirmation_loaded', function (event, formId) {
		if (formId === 2) {
			if (typeof fbq === 'function') {
				fbq('track', 'Lead');
			}
			if (typeof gtag === 'function') {
				gtag('event', 'Contact', {
					'event_category': 'Form Submit',
					'event_label': 'Contact Form',
					'send_to': 'UA-80664861-9'
				});
			}
		}
		if (formId === 3) {
			if (typeof fbq === 'function') {
				fbq('track', 'Lead');
			}
			if (typeof gtag === 'function') {
				gtag('event', 'Lead', {
					'event_category': 'Form Submit',
					'event_label': 'Party Inquiry Form',
					'send_to': 'UA-80664861-9'
				});
			}
		}
		if (formId === 4) {
			if (typeof fbq === 'function') {
				fbq('track', 'CompleteRegistration');
			}
			if (typeof gtag === 'function') {
				gtag('event', 'Newsletter', {
					'event_category': 'Form Submit',
					'event_label': 'Newsletter Form',
					'send_to': 'UA-80664861-9'
				});
			}
		}
	});

	$("[href*='tel:']").click(function (e) {
		e.preventDefault();
		var href = $(this).attr('href');

		if (typeof fbq === 'function') {
			fbq('track', 'Contact');
			fbq('trackCustom', 'Davis - Click To Call');
		}

		if (typeof gtag === 'function') {
			gtag('event', 'Contact', {
				'event_category': 'Click to Call',
				'event_label': href.replace('tel:', ''),
				'send_to': 'UA-80664861-9'
			});
		}

		setTimeout(function () {
			window.location = href;
		}, 500);
	});

	$("[href*='opentable']").click(function (e) {

		if (typeof fbq === 'function') {
			fbq('trackCustom', 'Davis - OpenTable Click');
		}

		if (typeof gtag === 'function') {
			gtag('event', 'Opentable', {
				'event_category': 'Reservation',
				'send_to': 'UA-80664861-9'
			});
		}

	});


	$("[href*='maps']").click(function (e) {
		e.preventDefault();
		var href = $(this).attr('href');

		if (typeof fbq === 'function') {
			fbq('track', 'FindLocation');
			fbq('trackCustom', 'Davis - Get Directions');
		}

		if (typeof gtag === 'function') {
			gtag('event', 'Get Directions', {
				'event_category': 'Get Directions',
				'event_label': href,
				'send_to': 'UA-80664861-9'
			});
		}

		setTimeout(function () {
			window.location = href;
		}, 500);
	});

	$('.wrapper [data-toggle]').click(function(e) {
		e.preventDefault();

		var target = $(this).data('toggle');

		$('#'+target).fadeIn();
	
		$('#'+target+' .close').click(function (e) {
			e.preventDefault();
			$('#'+target).fadeOut();
		});


	});



})(jQuery);


